
import React from "react";
import { motion } from "framer-motion";

const FloatingAnimations = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <motion.div 
        className="absolute top-20 left-[10%] w-16 h-16 bg-madts-pink rounded-full opacity-20"
        animate={{ 
          y: [0, -30, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          repeat: Infinity,
          duration: 5,
          ease: "easeInOut" 
        }}
      />
      <motion.div 
        className="absolute top-40 right-[15%] w-24 h-24 bg-madts-blue rounded-full opacity-20"
        animate={{ 
          y: [0, -40, 0],
          scale: [1, 1.1, 1]
        }}
        transition={{ 
          repeat: Infinity,
          duration: 7,
          ease: "easeInOut" 
        }}
      />
      <motion.div 
        className="absolute bottom-40 left-[20%] w-20 h-20 bg-madts-purple rounded-full opacity-20"
        animate={{ 
          y: [0, -20, 0],
          scale: [1, 1.3, 1]
        }}
        transition={{ 
          repeat: Infinity,
          duration: 6,
          ease: "easeInOut" 
        }}
      />
    </div>
  );
};

export default FloatingAnimations;
